<style lang="css" scoped>
.tools {
  margin-bottom: 10px;
}
</style>

<template>
  <div>
    <div class="tools">
      <i-button @click="down">导出</i-button>
    </div>
    <i-table highlight-row :columns="columns" :data="source"></i-table>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import download from 'downloadjs';

export default {
  data() {
    return {
      station: '',
      type: '',
      query: '',
      page: {
        total: 0,
        current: 1,
        pagesize: 10,
      },
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
        },
        {
          title: '单号',
          key: 'no',
        },
        {
          title: '仓库',
          key: 'station',
        },
        {
          title: '编码',
          key: 'categoryId',
        },
        {
          title: '名称',
          key: 'name',
        },
        {
          //   title: '销售价',
          //   key: 'price'
          // }, {
          title: '数量',
          key: 'count',
        },
        {
          title: '成本',
          key: 'cost',
        },
        {
          title: '总成本',
          key: 'totalAmount',
        },
        {
          title: '状态',
          key: 'state',
        },
        {
          title: '时间',
          key: 'createdAt',
        },
      ],
      source: [],
      currentRow: null,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    pageChange() {
      this.load();
    },
    load() {
      this.$http.post('monitor/warehouse').then(({ data }) => {
        if (data.msg === 'ok') {
          this.source = data.rows.map((r) => {
            r.createdAt = dayjs(r.createdAt).format('YYYY-MM-DD');
            r.state = `剩余${r.count - r.return}`;
            return r;
          });
        }
      });
    },
    down() {
      this.$http.post('monitor/warehouse/export').then(({ data }) => {
        if (data.msg === 'ok') {
          download(
            'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
              data.base64
          );
        }
      });
    },
  },
};
</script>
